import { ProductController } from "controllers";
import { useEffect, useState } from "react";
import { datePipe, titleCasePipe } from "shared/pipes";

const tooltipMap = (itemStatus) => {
    const status = itemStatus?.toLowerCase();
    switch (status) {
        case 'at_customer':
            return 'addedToBox';
        case 'missing':
            return 'declared_missing';
        case 'kept':
            return 'declared_kept';
        case 'returned':
            return 'processedReturn';
        default:
            return null;
    }
}

const statusMap = (itemStatus) => {
    const status = itemStatus?.toLowerCase();
    switch (status) {
        case 'at_customer':
        case 'pending':
            return 'is-dark';
        case 'missing':
            return 'is-danger';
        case 'late':
        case 'kept':
            return 'is-warning';
        case 'returned':
        case 'available':
            return 'is-success';
        case 'not_picked_up':
        case 'archived':
            return 'is-info';
        case 'bought':
            return 'is-primary';
        default:
            return 'is-white';
    }
}

const ItemStatusTag = ({ item, className = '' }) => {
    const status = item?.status || 'No Status';
    const statusColor = statusMap(status);

    return (
        <span className={`tag is-uppercase ${statusColor} ${className}`}>
            {titleCasePipe.transform(status)}
        </span>
    );
}

const ItemStatusTagWrapper = ({ item, box, className = '' }) => {
    const [log, setLog] = useState({});

    const tooltip = () => {
        const field = tooltipMap(item.status);
        return box && field ? datePipe.transform(log[field]) : null;
    }

    useEffect(() => {
        const getLogs = async () => {
            const l = await ProductController.getProductLogByBoxId(item.barcode, box.id);
            setLog(l);
        }

        if (box) {
            getLogs();
        }
    }, [item, box]);

    return (
        <span className="has-tooltip-arrow" data-tooltip={tooltip()}>
            <ItemStatusTag item={item} className={className} />
        </span>
    );
}

export { ItemStatusTagWrapper as ItemStatusTag };
